import { render, staticRenderFns } from "./ListingDetails.vue?vue&type=template&id=60c4dd7a&scoped=true&"
import script from "./ListingDetails.vue?vue&type=script&lang=ts&"
export * from "./ListingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ListingDetails.vue?vue&type=style&index=0&id=60c4dd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4dd7a",
  null
  
)

export default component.exports